import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import CreatableSelect from 'react-select/creatable';
import PropTypes from 'prop-types';
import { NOTIFICATION_LEVEL_ERROR } from '@avtechsoftware/ra-javascript-utilities/src/types/NotificationLevels';
import { createTag, selectTagList } from '../../../../../redux/slices/tagListSlice/tagListSlice';
import { selectSessionInformation } from '../../../../../redux/slices/sessionSlice';
import { pushSessionMessage } from '../../../../../redux/slices/toastNotificationSlice/toastNotificationSlice';

function TagsMultiSelect({ selectedTags, setSelectedTags }) {
  const dispatch = useDispatch();
  const tagList = useSelector((state) => selectTagList(state));
  const { activeSubscription } = useSelector(selectSessionInformation);

  const onChange = async (tags, { action }) => {
    if (action === 'create-option') {
      const createdTagOption = tags[tags.length - 1];
      const newTag = {
        name: createdTagOption.label,
        alertTagList: [],
        deviceTagList: [],
      };
      try {
        const { id } = await dispatch(createTag(
          {
            subscriptionId: activeSubscription.id,
            tag: { ...newTag },
          },
        )).unwrap();
        newTag.id = id;
        setSelectedTags([...selectedTags, newTag]);
      } catch (e) {
        dispatch(pushSessionMessage(
          {
            level: NOTIFICATION_LEVEL_ERROR,
            title: 'Save Error',
            body: 'Error Saving New Tag.',
          },
        ));
      }
    } else {
      const tagObjects = tags.map((tag) => tagList.find((tl) => tl.id === tag.value));
      setSelectedTags(tagObjects);
    }
  };

  const getOptions = () => tagList.map((tag) => ({ value: tag.id, label: tag.name }));

  // Resolve tag names from tagList for tags that only have an id
  const getSelectedValue = () => selectedTags.map((tag) => {
    // If tag already has a name, use it
    if (tag && tag.name) {
      return { value: tag.id, label: tag.name };
    }
    // Otherwise, look up the name from tagList
    const tagId = tag && typeof tag === 'object' ? tag.id : tag;
    const fullTag = tagList.find((t) => t.id === tagId);
    return {
      value: tagId,
      label: fullTag ? fullTag.name : '',
    };
  });

  return (
    <CreatableSelect
      isMulti
      styles={{
        container: (base) => ({
          ...base,
          width: '100%',
        }),
      }}
      isClearable={false}
      options={getOptions()}
      onChange={onChange}
      value={getSelectedValue()}
      formatCreateLabel={(inputText) => `Create new tag ${inputText}`}
    />
  );
}

TagsMultiSelect.propTypes = {
  selectedTags: PropTypes.arrayOf(PropTypes.string).isRequired,
  setSelectedTags: PropTypes.func.isRequired,
};

export default TagsMultiSelect;
